import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/Dormitories.module.styl'
import img1 from '~/assets/img/Fachada.jpg'
import img2 from '~/assets/img/Vista-aerea.jpg'
import { useLanguage } from '~/hooks'

export default function Dormitories() {
  const { t } = useLanguage()
  return (
    <section className={st.core} id="Empreendimento">
      <div className={st.logo}>
        <span></span>
      </div>
      <Lazyload src={img1} className={st.img1} />
      <Lazyload src={img2} className={st.img2} />
      <div className={st.dorms}>
        <h2>{t('Dormitories.title')}</h2>
        <h3>{t('Dormitories.area')}</h3>
      </div>
    </section>
  )
}
